import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const compassProductSettingsRoute: InvariantJiraRoute = {
	name: 'compass-product-settings',
	path: '/jira/settings/products/compass',
	exact: true,
};
